import React from 'react'

const Navbar = () => {
  return (
    <div className="navbarWrapper"></div>
  )
}

export default Navbar